import React from 'react'
import our from '../../Assete/fp1_1950x1000.jpg'
import our1 from '../../Assete/i (1).webp'
function AboutSection() {
  return (
    <div className='container mission_about mt-5'>
      <div className="row m-0">
        <div className='col-lg-6 col-md-12 col-12'>
          <h4>Global <span>Connection</span> & Opportunity</h4>
          <p><span style={{ color: "#94CB85", fontWeight: "bold" }}>EdFura</span> is a comprehensive and trusted platform dedicated to supporting the academic and professional growth of students, researchers and professionals in the field of Biological Sciences. We aim to bridge the gap between education and career by providing centralized access to a wide range of scholarship opportunities, internships, fellowships and job listings tailored specifically for the biological sciences.
            We recognize the challenges that aspiring biologists and established professionals face in navigating the complex landscape of funding, education and employment. By curating and regularly updating verified opportunities from academic institutions, research organizations, private companies and government agencies, we strive to remove barriers to success and make career development in biology more accessible and equitable.
          </p>
          <h4>Growth & <span>Educational</span> Advancement</h4>
          <p>Our platform is more than a job board—it is a growing community committed to the advancement of biological sciences. Through informative resources, expert insights and connections to real-world opportunities, we aim to inspire innovation, encourage lifelong learning and support the diverse and dynamic individuals who are shaping the future of biology.
            Whether you are a high school student aspiring to pursue a degree in biology, a graduate student seeking research funding or a seasoned professional exploring new career paths, our goal is to empower you with the tools and opportunities needed to thrive in your journey.
          </p>
        </div>
        <div className='col-lg-6 col-md-12 col-12'>
          <div className='img_section'>
            <div className='img1'>
              <img src={our} alt='' />
            </div>
            <div className='img2'>
              <img src={our1} alt='' />
            </div>
          </div>
          <div className='img_section1'>
            <div className='img1'>
              <img className='w-100 mb-3 rounded-3' src={our} alt='' />
            </div>
            <div className='img2'>
              <img className='w-100 mb-3 rounded-3' src={our1} alt='' />
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default AboutSection